import { on } from 'delegated-events'

const closeOtherTabs = (activeTrigger) => {
  const container = activeTrigger.closest('[role="tablist"]')
  const otherTriggers = Array.from(container.querySelectorAll('[role="tab"][aria-selected="true"]')).filter(
    (x) => x !== activeTrigger
  )

  otherTriggers.forEach((x) => closeTab(x))
}

const openTab = (trigger) => {
  const panel = document.getElementById(trigger.getAttribute('aria-controls'))

  trigger.setAttribute('aria-selected', 'true')
  panel.setAttribute('aria-hidden', 'false')
}

const closeTab = (trigger) => {
  const panel = document.getElementById(trigger.getAttribute('aria-controls'))

  trigger.setAttribute('aria-selected', 'false')
  panel.setAttribute('aria-hidden', 'true')
}

const handleTab = (e) => {
  e.preventDefault()

  const trigger = e.target.closest('[role="tab"]')

  if (trigger.getAttribute('aria-selected') === 'false') {
    openTab(trigger)
    closeOtherTabs(trigger)
  }
}

on('click', '[role="tab"]', handleTab)
